import { mainProps, autoProps, audioProps } from "./defaultValues";

export const isValidString = (str) => {
  if (str === "") {
    console.error('str === "", str -> ' + str);
    return false;
  }
  if (typeof str !== "string") {
    console.error('typeof str !== "string", str -> ' + str);
    return false;
  }

  const splitted = str.split(";");
  if (splitted.length !== 11) {
    console.error("splitted.length !== 11, splitted -> " + splitted);
    return false;
  }
  return true;
};
export const isValidObject = (obj) => {
  if (typeof obj !== "object") {
    console.error('typeof obj !== "object", obj === ' + obj);
    return false;
  }
  if (obj === null) {
    console.error("obj === null, obj ===" + obj);
    return false;
  }
  if (typeof obj.auto !== "object") {
    console.error('typeof obj.auto !== "object",  obj.auto === ' + obj.auto);
    return false;
  }
  if (obj.auto === null) {
    console.error("obj.auto === null, obj.auto ===", obj.configsX);
    return false;
  }
  if (typeof obj.audio !== "object") {
    console.error('typeof obj.audio !== "object", obj.audio ===  ' + obj.audio);
    return false;
  }
  if (obj.audio === null) {
    console.error("obj.audio === null, obj.audio === " + obj.audio);
    return false;
  }

  if (!mainProps.every((p) => obj.hasOwnProperty(p))) {
    console.error(`!main.every((p) => obj.hasOwnProperty(p))`);
    console.error(`obj === ${obj}, main === ${mainProps}`);
    return false;
  }
  if (!autoProps.every((p) => obj.auto.hasOwnProperty(p))) {
    console.error(`!autoProps.every((p) => obj.auto.hasOwnProperty(p))`);
    console.error(`obj.auto - ${obj.auto}, configs - ${autoProps}`);
    return false;
  }
  if (!audioProps.every((p) => obj.audio.hasOwnProperty(p))) {
    console.error(`!audioProps.every((p) => obj.audio.hasOwnProperty(p))`);
    console.error(`obj.audio - ${obj.audio}, audioProps - ${audioProps}`);
    return false;
  }
  return true;
};
export const betCheck = (n, minBet, maxBet, defaultValue) => {
  if (isNaN(+n)) {
    console.error(`bet was not a number, it was ${n}`);
    return Number(defaultValue) > 0 ? defaultValue : minBet;
  }
  if (+n > maxBet) {
    console.error(`bet was more than maxBet, bet was ${n}`);
    return Number(defaultValue) <= maxBet ? defaultValue : maxBet;
  }
  if (+n < minBet) {
    console.error(`bet was less than minBet, bet was ${n}`);
    return Number(defaultValue) > 0 ? defaultValue : minBet;
  }
  return n;
};
export const numberOfBetsCheck = (n, defaultValue) => {
  if (n === "") return n;
  if (isNaN(+n)) {
    console.error("numberOfBets was not a number, it was " + n);
    return defaultValue;
  }
  if (+n < 0) {
    console.error("numberOfBets was below 0, it was " + n);
    return defaultValue;
  }
  if (+n % 1 !== 0) {
    console.error("numberOfBets was not whole number, it was " + n);
    return defaultValue;
  }
  return n;
};
export const onWinResetCheck = (n, defaultValue) => {
  if (typeof n !== "boolean") {
    console.error("onWinReset was not a boolean, it was " + n);
    return defaultValue;
  }
  return n;
};
export const onWinPercentCheck = (n, defaultValue) => {
  if (isNaN(+n)) {
    console.error("onWinPercent was not a number, it was " + n);
    return defaultValue;
  }
  return n;
};
export const onLossResetCheck = (n, defaultValue) => {
  if (typeof n !== "boolean") {
    console.error("onLossReset was not a boolean, it was " + n);
    return defaultValue;
  }
  return n;
};
export const onLossPercentCheck = (n, defaultValue) => {
  if (isNaN(+n)) {
    console.error("onLossPercent was not a number, it was " + n);
    return defaultValue;
  }
  return n;
};
export const stopOnProfitCheck = (n, defaultValue) => {
  if (isNaN(+n)) {
    console.error("stopOnProfit was not a number, it was " + n);
    return defaultValue;
  }
  if (n < 0) {
    console.error("stopOnProfit was below 0, it was " + n);
    return defaultValue;
  }
  return n;
};
export const stopOnLossCheck = (n, defaultValue) => {
  if (isNaN(+n)) {
    console.error("stopOnLoss was not a number, it was " + n);
    return defaultValue;
  }
  if (+n < 0) {
    console.error("stopOnLoss was below 0, it was " + n);
    return defaultValue;
  }
  return n;
};
export const musicCheck = (n, defaultValue) => {
  if (typeof n !== "boolean") {
    console.error("music was not a boolean, it was " + n);
    return defaultValue;
  }
  return n;
};
export const soundCheck = (n, defaultValue) => {
  if (typeof n !== "boolean") {
    console.error("sound was not a boolean, it was " + n);
    return defaultValue;
  }
  return n;
};
export const volumeCheck = (n, defaultValue) => {
  if (isNaN(+n)) {
    console.error("volume was not a number, it was " + n);
    return defaultValue;
  }
  if (+n > 1) {
    console.error("volume was more than 1, it was " + n);
    return defaultValue;
  }
  if (+n < 0) {
    console.error("volume was less than 0, it was " + n);
    return defaultValue;
  }
  return n;
};
